import { Pipe, PipeTransform }          from '@angular/core';
//**************************************************************
// Field Definitions
import { whoseguestinit  }                from '../appfirestore/app.fields';
//**************************************************************
@Pipe( { name: 'getinitial' })

// Syntax -> Street: {{ val | getinitial:20 }} where val is the value
//**************************************************************
export class getorganiserinitpipe implements PipeTransform
    {
        //**************************************************************
        //  transform( value: Array<whoseguestinit>, arraylength: number )
        transform( value: any, organiserid: string, arraylength: number, selreturn: number )
       
            {
                
                var initial: string = '';

                if ( arraylength > 0 )
                    {
                        switch ( selreturn )
                            {
                               case 1:
                                   {
                                        initial = value.find( x=>x.id == organiserid ).initial
                                      break;
                                   }

                             case 10:
                                    {
                                        initial = value.find( x=>x.id == organiserid ).fullname
                                        break;
                                    }
                            }
                    }
             
                return initial;

            }
        //**************************************************************    
    }
//**************************************************************